(function($){
	'use strict';

	$(document).ready(function (){
		xttLoadMorePosts.handleEvents();
	});

	var xttLoadMorePosts = {
		
		handleEvents : function(){
			$('.btn-load-more').on('click', xttLoadMorePosts.loadMorePosts);
		},

		loadMorePosts : function(event) {
			var $button = jQuery(this);
			
			if(!$button.hasClass('btn-loading')) {
				$button.addClass('btn-loading');

				$.ajax({
					url : $button.attr('href'),
					context: $button,
					dataType: 'html'
				}).done(xttLoadMorePosts.renderMorePosts).fail(xttLoadMorePosts.renderMorePostsError);
				
			}
			event.preventDefault();
		},

		renderMorePosts : function(data) {
			var $nextPage = jQuery(data);
			var $ajaxContainer = jQuery('.archive-list-ajax');
			var $newAjaxContainer = $nextPage.find('.archive-list-ajax');
			var nextPageHref = $nextPage.find('.btn-load-more').attr('href');

			$newAjaxContainer.find('> .archive-item-ajax').appendTo($ajaxContainer);

			var currentPage = $newAjaxContainer.data('page');
			var maxPages = $ajaxContainer.data('pages');
			$ajaxContainer.data('page', currentPage);

			var $button = jQuery(this);
			$button.removeClass('btn-loading');

			if (maxPages === currentPage){
				$button.hide();
			}

			jQuery('.btn-load-more').attr('href', nextPageHref);

			//$button.trigger('after-render-page.xtt');
		},

		renderMorePostsError : function(){
			var $button = jQuery(this);
			$button.removeClass('btn-loading');
		}

	};

})(jQuery);